import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ShowToastErrorAction } from './app-error.actions';
import { ToastController } from '@ionic/angular';

export class AppErrorStateModel {
  public items: string[];
}

const defaults = {
  items: [],
};

@State<AppErrorStateModel>({
  name: 'appError',
  defaults,
})
@Injectable()
export class AppErrorState {
  constructor(private readonly _toastController: ToastController) {}

  @Action(ShowToastErrorAction)
  async showToastErrorAction(
    { getState, setState }: StateContext<AppErrorStateModel>,
    { message, icon, duration }: ShowToastErrorAction,
  ) {
    const toast = await this._toastController.create({
      message: message || 'An error has occurred',
      duration: duration || 1500,
      icon: icon || 'warning',
      cssClass: 'toast-error',
    });

    await toast.present();
  }
}
